import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Card,
  CircularProgress,
} from "@material-ui/core";
import { Alert } from '@material-ui/lab';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ThermalSalesReportIMIN from "./ThermalSalesReportIMIN"; // Import the component
import ThermalSalesReport from "./ThermalSalesReport";
import { fetchInvoicesByDateRange } from "../../api";

const DSRDialog = ({
  open,
  onClose,
  date,
  handleDateChange,
  startDate,
  handleStartDateChange,
  endDate,
  handleEndDateChange,
  handleSubmit,
  showPreview,
  rows, // This will be ignored now, we'll fetch our own data
  user,
  classes,
}) => {
  // State for managing fetched invoices
  const [fetchedInvoices, setFetchedInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to detect if the system is Windows using navigator.userAgent
  const isWindows = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes("windows");
  };

  // Function to fetch invoices by date range
  const fetchInvoices = async (startDate, endDate) => {
    try {
      setLoading(true);
      setError(null);
      
      // Format dates for API
      const startDateStr = startDate.toISOString().split('T')[0];
      const endDateStr = endDate.toISOString().split('T')[0];
      
      const response = await fetchInvoicesByDateRange(startDateStr, endDateStr);
      setFetchedInvoices(response.data);
    } catch (err) {
      setError(err.message || 'Failed to fetch invoices');
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch invoices when showPreview becomes true
  useEffect(() => {
    if (showPreview && startDate && endDate) {
      fetchInvoices(startDate, endDate);
    }
  }, [showPreview, startDate, endDate]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }} // You can adjust this to control the width (e.g., 'sm', 'md', 'lg')
      ps={{
        style: {
          poPaperProsition: "absolute",
          top: "38%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Centers the dialog
          width: "32%", // Adjust width as needed
          maxHeight: "88vh", // Optional: Limits height to avoid overflow
          // overflowY: "auto", // Optional: Adds scroll if content overflows
        },
      }}
    >
      <DialogTitle>Daily Sales Report</DialogTitle>
      <DialogContent>
        <div className={classes.controls}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginBottom: '16px' }}>
              <KeyboardDatePicker
                margin="normal"
                label="Start Date"
                format="dd/MM/yyyy"
                value={startDate}
                onChange={handleStartDateChange}
                className={classes.datePicker}
              />
              <KeyboardDatePicker
                margin="normal"
                label="End Date"
                format="dd/MM/yyyy"
                value={endDate}
                onChange={handleEndDateChange}
                className={classes.datePicker}
              />
            </div>
            <div style={{ display: 'none', gap: '16px', alignItems: 'center', marginBottom: '16px' }}>
              <KeyboardDatePicker
                margin="normal"
                label="Single Date (Alternative)"
                format="dd/MM/yyyy"
                value={date}
                onChange={handleDateChange}
                className={classes.datePicker}
              />
            </div>
          </MuiPickersUtilsProvider>

          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Search Report
          </Button>
        </div>

        {showPreview && (
          <Card className={classes.previewCard}>
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <CircularProgress />
              </div>
            ) : error ? (
              <Alert severity="error" style={{ margin: '20px' }}>
                {error}
              </Alert>
            ) : (
              <>
                {isWindows() ? (
                  <ThermalSalesReport
                    userProfile={user.userProfile}
                    salesData={{
                      invoices: fetchedInvoices, // Pass all invoices, component will filter by date
                  isPrintReport: true,
                }}
                selectedDate={date}
                startDate={startDate}
                endDate={endDate}
              />
            ) : (
              <ThermalSalesReportIMIN
                userProfile={user.userProfile}
                salesData={{
                  invoices: fetchedInvoices, // Pass all invoices, component will filter by date
                  isPrintReport: true,
                }}
                selectedDate={date}
                startDate={startDate}
                endDate={endDate}
              />
            )}
              </>
            )}
          </Card>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DSRDialog;
